import React, { Component } from "react";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
  setCookieOneHr,
} from "../global/browserFunctions";


class EachItem extends Component {
  constructor(props) {
    super(props);
    this.state = { product: this.props.product, img:"", name:"", link:"", price:"" };
  }

  componentDidMount(){
    this.setState({ product: this.state.product }, function(){
      var pricelevel = getCookie("pricelevel") || "1";
      var image= this.state.product && this.state.product.item_image_thumbnail_url && this.state.product.item_image_thumbnail_url.value;
      var name= this.state.product && this.state.product.item_itemid && this.state.product.item_itemid.value;
      var link= this.state.product && this.state.product.item_detailspage_url && this.state.product.item_detailspage_url.value;
      var basePrice= this.state.product && this.state.product.price_levels && this.state.product.price_levels[1] && this.state.product.price_levels[1].item___pricing_unitprice && this.state.product.price_levels[1].item___pricing_unitprice.value;
      var customerPrice= this.state.product && this.state.product.price_levels && this.state.product.price_levels[pricelevel] && this.state.product.price_levels[pricelevel].item___pricing_unitprice && this.state.product.price_levels[pricelevel].item___pricing_unitprice.value;
      var price= basePrice || customerPrice;
      if(!price){
          var item = this.state.product;
          basePrice = item && item.child_items[Object.keys(item.child_items)[0]].price_levels && item.child_items[Object.keys(item.child_items)[0]].price_levels[1] && item.child_items[Object.keys(item.child_items)[0]].price_levels[1].item___pricing_unitprice.value;
          customerPrice = item && item.child_items[Object.keys(item.child_items)[0]].price_levels && item.child_items[Object.keys(item.child_items)[0]].price_levels[pricelevel] && item.child_items[Object.keys(item.child_items)[0]].price_levels[pricelevel].item___pricing_unitprice.value;
          price = basePrice || customerPrice;
      }
      this.setState({ img: image });
      this.setState({ name: name });
      this.setState({ link: link });
      this.setState({ price: price }, function(){
        this.forceUpdate();
      });
    }); 
  
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.product != nextProps.product) {
      this.setState({ product: nextProps.product }, function(){
        var pricelevel = getCookie("pricelevel") || "1";
        var image= this.state.product && this.state.product.item_image_thumbnail_url && this.state.product.item_image_thumbnail_url.value;
        var name= this.state.product && this.state.product.item_itemid && this.state.product.item_itemid.value;
        var link= this.state.product && this.state.product.item_detailspage_url && this.state.product.item_detailspage_url.value;
          var basePrice= this.state.product && this.state.product.price_levels && this.state.product.price_levels[1] && this.state.product.price_levels[1].item___pricing_unitprice && this.state.product.price_levels[1].item___pricing_unitprice.value;
          var customerPrice= this.state.product && this.state.product.price_levels && this.state.product.price_levels[pricelevel] && this.state.product.price_levels[pricelevel].item___pricing_unitprice && this.state.product.price_levels[pricelevel].item___pricing_unitprice.value;
          var price= basePrice || customerPrice;
          if(!price){
              var item = this.state.product;
              basePrice = item && item.child_items[Object.keys(item.child_items)[0]].price_levels && item.child_items[Object.keys(item.child_items)[0]].price_levels[1] && item.child_items[Object.keys(item.child_items)[0]].price_levels[1].item___pricing_unitprice.value;
              customerPrice = item && item.child_items[Object.keys(item.child_items)[0]].price_levels && item.child_items[Object.keys(item.child_items)[0]].price_levels[pricelevel] && item.child_items[Object.keys(item.child_items)[0]].price_levels[pricelevel].item___pricing_unitprice.value;
              price = basePrice || customerPrice;
          }

        this.setState({ img: image });
        this.setState({ name: name });
        this.setState({ link: link });
        this.setState({ price: price });
      });
      
      return true;
    }
    return false;
  }
  render() {
    return (
      <React.Fragment>
       <div className="product" data-aos="zoom-in" data-aos-delay="0">
            <div className="product-image mb-md-3">
                    <a href={this.state.link}>
                        <img className="img-fluid" src={this.state.img} alt="item_img" />
                    </a>
            </div>
            <div className="position-relative text-center">
                <h3 className="text-base mb-1">
                        <a className="text-dark" href={this.state.link} >{this.state.name}</a>
                </h3>
                <span className="text-gray-500 text-sm">${this.state.price}</span>
            </div>
        </div>
      </React.Fragment>
    );
  }
}
export default EachItem;
